<template>
  <div class="category-filter filter-form">
    <p class="star-btn">
      <button v-for="n in 5" :key="n" @click="update(n)">
        <fa fa-class="star" :solid="n <= selected" :padding="false" />
      </button>
    </p>

    <p class="text-right">
      <b-button class="btn-as-link" @click="reset">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
import filtersMixin from '@/components/frontoffice/Booking/filters/mixin'
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    fa
  },

  mixins: [filtersMixin],

  data () {
    return {
      defaultSelected: 0
    }
  },

  mounted () {
    this.selected = this.initSelected
  },

  methods: {
    reset () {
      // if (this.hasInit) this.update(this.defaultSelected)
      // else this.selected = this.defaultSelected
      //
      // this.hasInit = true
      this.update(this.defaultSelected)
    },

    update (stars) {
      if (stars !== this.selected) {
        this.selected = stars
        this.emitChanges()
      }
    }
  }
}
</script>
